import { guid } from '@/mixins/guid';

const siteBuilder = {
  mixins: [guid],
  methods: {
    async callBuilder(payload) {
      if (!this._published && payload.type !== 'preview') {
        this.$log.info('Site not live, no build ran.');
        return {};
      }
      payload.timeZone = this._timeZone;
      const response = await this.$lightning([{
        name: 'callBuilder',
        payload,
      }]);
      this.$log.debug('Site builder update: ', response);
      // if user has webhooks enabled on publish events, we need to warn of failures
      if (response.webhookWarnings && response.webhookWarnings.length > 0) {
        let failedHooks = '';
        response.webhookWarnings.forEach((item) => {
          failedHooks +=
            `<strong>Hook: </strong>${item.hook}<br><strong>Error: </strong><span class="adminUi-danger-txt">${item.error}</span><hr class="editorUi-notif-hr"/>`;
        });
        this.$store.dispatch('addNotification', {
          id: this.guid(),
          type: 'warning',
          message: `Your site successfully published but the following webhooks had issues:<br>${failedHooks}`,
        });
      }
      return response;
    },
  },
};

export { siteBuilder };



// WEBPACK FOOTER //
// ./src/mixins/site-builder.js